import { FC } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import strings from '@localizedstrings/LocalisedStrings';
import { wealthO2TermsAndConditionsUrl, wealthO2PrivacyPolicyUrl, contactUsUrl, wealthO2HomePageUrl } from '@utils/UrlBuilder';
import './_footer.scss';
import { useMediaQuery, useTheme } from '@mui/material';
import Colors from '@src/app/config/colorConfig';

const Footer: FC = (): JSX.Element => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Box component="footer" zIndex={!isMd ? theme.zIndex.drawer + 1 : theme.zIndex.appBar} sx={{ background: theme.palette.secondary.main }}>
      <Container>
        <Box sx={{ typography: 'body1' }} className="appFooterLinks">
          <Link href={wealthO2TermsAndConditionsUrl()} color={Colors.white} target="_blank">
            {strings.termsAndConditions}
          </Link>
          <Link href={wealthO2PrivacyPolicyUrl()} color={Colors.white} target="_blank">
            {strings.privacyPolicy}
          </Link>
          <Link href={contactUsUrl()} color={Colors.white} target="_blank">
            {strings.contactUs}
          </Link>
          <Link href={wealthO2HomePageUrl()} color={Colors.white} target="_blank">
            &copy; {strings.dashTechnologyGroup}
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
